<table class="table participants clickable">
    <thead>
        <tr>
            <th></th>
            <th *ngIf="!isLegalPerson">
                {{ 'form.participants' | translate }}
            </th>
            <th>{{ 'form.name-and-surname' | translate }}</th>
            <th class="d-none d-md-table-cell">
                {{ 'form.document' | translate }}
            </th>
            <th class="d-none d-md-table-cell">
                {{ 'form.phone' | translate }}
            </th>
            <th class="d-none d-md-table-cell" *ngIf="!isLegalPerson">
                {{ 'form.condition' | translate }}
            </th>
            <th class="text-right" *ngIf="!isAdmin">
                {{ 'form.status' | translate }}
            </th>
            <th class="text-right" *ngIf="isAdmin">
                {{ 'form.validated' | translate }}
            </th>
        </tr>
    </thead>
    <tbody>
        <ng-template ngFor let-participant [ngForOf]="participants" let-isFirst="first">
            <ng-container *ngIf="!isLegalPerson || (isLegalPerson && !isFirst)">
                <tr [class.gray]="participant.legalGuardians && participant.legalGuardians.length > 0" (click)="onEdit(participant)">
                    <td [ngSwitch]="participant.type">
                        <i class="icon-legal" *ngSwitchCase="ClientType.LEGAL_PERSON"></i>
                        <i class="icon-minor-plus" *ngSwitchCase="ClientType.MINOR"></i>
                        <i class="icon-disabled-plus" *ngSwitchCase="ClientType.DISABLED"></i>
                        <i class="icon-natural-plus" *ngSwitchDefault></i>
                    </td>
                    <td *ngIf="!isLegalPerson">
                        <ng-container *ngIf="participant.isAttorneyInFact">
                            <strong class="text-uppercase text-blue">{{ 'form.attorney-in-fact' | translate }}</strong>
                        </ng-container>
                        <ng-container *ngIf="!participant.isAttorneyInFact" [ngSwitch]="participant.relation">
                            <strong class="text-uppercase text-blue" *ngSwitchCase="ClientRelation.AUTHORIZED">{{
                                'form.authorized' | translate
                                }}</strong>
                            <strong class="text-uppercase text-blue" *ngSwitchDefault>
                                <ng-container *ngIf="participant.isSoleHolder">{{ 'form.holder' | translate }}
                                </ng-container>
                                <ng-container *ngIf="!participant.isSoleHolder">{{ 'form.co-holder' | translate }}
                                </ng-container>
                            </strong>
                        </ng-container>
                    </td>
                    <td>
                        <strong>{{ participant.name }}</strong>&nbsp;<strong>{{ participant.surname }}</strong>
                    </td>
                    <td class="d-none d-md-table-cell">
                        <strong>{{ participant.docId }}</strong>
                    </td>
                    <td class="d-none d-md-table-cell">
                        <strong>{{ participant.phone }}</strong>
                    </td>
                    <td class="d-none d-md-table-cell" *ngIf="!isLegalPerson" [ngSwitch]="participant.type">
                        <strong class="text-uppercase text-blue" *ngSwitchCase="ClientType.MINOR">
                            {{ 'form.minor-person' | translate }}
                        </strong>
                        <strong class="text-uppercase text-blue" *ngSwitchCase="ClientType.DISABLED">
                            {{ 'form.disabled-person' | translate }}
                        </strong>
                        <strong *ngSwitchDefault> - </strong>
                    </td>
                    <td *ngIf="!isAdmin">
                        <i class="icon-check green-icon-check float-right" *ngIf="participant.isComplete(isGDC)"></i>
                        <i class="icon-exclamation red-icon-exclamation float-right" *ngIf="!participant.isComplete(isGDC)"></i>
                    </td>
                    <td *ngIf="isAdmin">
                        <i class="icon-check green-icon-check float-right" *ngIf="participant.isValidated(isAdminPBC) || participant.validation.isValid()"></i>
                        <i class="icon-exclamation red-icon-exclamation float-right" *ngIf="!participant.isValidated(isAdminPBC) && !participant.validation.isValid()"></i>
                    </td>
                </tr>
                <ng-template ngFor let-legalGuardian [ngForOf]="participant.legalGuardians" let-isFirstLG="first" let-isLastLG="last">
                    <tr [class.gray]="!isLastLG">
                        <td></td>
                        <td>
                            <span *ngIf="isFirstLG && participant.type === ClientType.DISABLED && participant.legalGuardians.length > 1">{{
                                'form.representatives' | translate }}:</span>
                            <span *ngIf="isFirstLG && participant.type === ClientType.DISABLED && participant.legalGuardians.length === 1">{{
                                'form.the-representative' | translate }}:</span>
                            <span *ngIf="isFirstLG && participant.type === ClientType.MINOR && participant.legalGuardians.length > 1">{{
                                'form.tutors' | translate }}:</span>
                            <span *ngIf="isFirstLG && participant.type === ClientType.MINOR && participant.legalGuardians.length === 1">{{
                                'form.the-tutor' | translate }}:</span>
                        </td>
                        <td>
                            <strong>{{ legalGuardian.name }}</strong>&nbsp;<strong>{{ legalGuardian.surname }}</strong>
                        </td>
                        <td class="d-none d-md-table-cell">
                            <strong>{{ legalGuardian.docId }}</strong>
                        </td>
                        <td class="d-none d-md-table-cell">
                            <strong>{{ legalGuardian.phone }}</strong>
                        </td>
                        <td class="d-none d-md-table-cell">
                            <strong>-</strong>
                        </td>
                        <td class="text-right"></td>
                    </tr>
                </ng-template>
            </ng-container>
        </ng-template>
    </tbody>
</table>
